document.addEventListener('DOMContentLoaded', function () {
  class AccordionContainer extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.accordionSteps = Array.from(this.querySelectorAll('accordion-step'))
      this.accordionSteps.forEach((accordionStep, _i) => {
        const stepHeading = accordionStep.querySelector('.heading')
        const stepDetails = accordionStep.querySelector('.detail')

        const onStepHeadingClick = (e) => {
          e.stopPropagation()
          if (!accordionStep.classList.contains('active')) {
            this.accordionSteps.forEach((_step) => _step.classList.remove('active'))
          }
          accordionStep.classList.toggle('active')
        }

        stepHeading.addEventListener('click', onStepHeadingClick)
      })
    }
  }

  customElements.define('accordion-container', AccordionContainer)
});